import { useEffect } from 'react';
import {
    getSettingsScrollRoot,
    getSettingsSectionElement,
    getSettingsSectionId,
    SETTINGS_ACTIVATION_OFFSET,
    SETTINGS_SCROLL_END_TOLERANCE,
} from './settingsNavigation';

const useSettingsScrollSpy = ({ sectionIds, pausedRef, onActiveChange }) => {
    useEffect(() => {
        const root = getSettingsScrollRoot();
        const elements = sectionIds.map(getSettingsSectionElement).filter(Boolean);

        if (!elements.length) return undefined;

        let frameId = null;
        let isDisposed = false;

        const updateActiveSection = () => {
            frameId = null;
            if (isDisposed || pausedRef.current) return;

            const rootRect = root?.getBoundingClientRect();
            const viewportTop = rootRect?.top || 0;
            const activationLine = viewportTop + SETTINGS_ACTIVATION_OFFSET;
            const isAtBottom = root
                ? root.scrollTop + root.clientHeight >= root.scrollHeight - SETTINGS_SCROLL_END_TOLERANCE
                : window.scrollY + window.innerHeight >=
                  document.documentElement.scrollHeight - SETTINGS_SCROLL_END_TOLERANCE;

            if (isAtBottom) {
                onActiveChange(sectionIds[sectionIds.length - 1]);
                return;
            }

            let currentActiveId = sectionIds[0];
            for (const element of elements) {
                if (element.getBoundingClientRect().top <= activationLine) {
                    currentActiveId = getSettingsSectionId(element);
                } else {
                    break;
                }
            }

            onActiveChange(currentActiveId);
        };

        const handleScroll = () => {
            if (frameId === null) frameId = window.requestAnimationFrame(updateActiveSection);
        };

        const scrollTarget = root || window;
        scrollTarget.addEventListener('scroll', handleScroll, { passive: true });
        updateActiveSection();

        return () => {
            isDisposed = true;
            scrollTarget.removeEventListener('scroll', handleScroll);
            if (frameId !== null) window.cancelAnimationFrame(frameId);
        };
    }, [onActiveChange, pausedRef, sectionIds]);
};

export default useSettingsScrollSpy;
